import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isNumber } from '@/utils';
import empty from '../empty.vue';
export default {
  name: 'yanchu_goods_nav',
  components: {
    empty: empty
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      activeNav: 0,
      navbarList: [{
        label: '综合排序'
      }, {
        label: '价格',
        icon: 'el-icon-d-caret'
      }]
    };
  },
  methods: {
    changeNav: function changeNav(index) {
      // this.activeNav = index
    }
  },
  computed: {
    goodsList: function goodsList() {
      if (isNumber(this.value.config.line_number)) {
        var _this$value$default_v;
        var _this$value$config$sh = this.value.config.show_type,
          show_type = _this$value$config$sh === void 0 ? 1 : _this$value$config$sh;
        var num_of_line = {
          1: 2,
          2: 1
        }[show_type];
        return ((_this$value$default_v = this.value.default_value) === null || _this$value$default_v === void 0 ? void 0 : _this$value$default_v.slice(0, num_of_line * this.value.config.line_number)) || [];
      }
      return this.value.default_value || [];
    }
  }
};